import { categoryReducer, CategoryState } from './category.reducer';
import { pricelevelReducer, PricelevelState } from './pricelevel.reducer';
import { categoryFormReducer, CategoryFormState } from './category-form.reducer';
import { ticketQuotaReducer, TicketQuotaState } from './ticket-quota.reducer'
import { MessageState, messageReducer } from './message.reducer';

import { storeLogger } from 'ngrx-store-logger';
import { compose } from '@ngrx/store';
import { combineReducers } from '@ngrx/store';
import { ActionReducerMap } from '@ngrx/store';

import * as fromEventsOnSale from "../components/events-on-sale";
import { shoppingCartReducer, ShoppingCartState } from '../components/shopping-cart/shopping-cart.reducer'
import { eventOverviewReducer, EventOverviewState } from './event-overview.reducer'
import { eventReducer, EventState } from './event.reducer'
import { eventCategoryReducer, EventCategoryState } from './event-category.reducer'
import { venueReducer, VenueState } from '../components/venue-components/venue.reducer'
import { customersReducer, CustomersState } from '../components/customer-management/customer.reducer'
import { ticketDesignReducer, TicketDesignState } from '../components/event-components/ticket-designs/ticket-design.reducer'
import { checkoutReducer, CheckoutState } from '../components/checkout-components/checkout.reducer';
import { OrderState, orderReducer } from '../components/order-components/order.reducer';
import { merchantsReducer, MerchantState } from '../components/merchants/merchant.reducer'
import { sponsorsReducer, SponsorState } from '../components/sponsors/sponsor.reducer';
import { seatingplanReducer, SeatingplanState }	 from '../components/seatingplan-components/seatingplan.reducer'
import { SeatingplanServerState, seatingplanServeReducer } from './seatingplan-server.reducer';
import { openItemsReducer, OpenItemsState } from '../components/open-items/open-items.reducer'
import { additionalChargeReducer, AdditionalChargeState } from './additional-charge.reducer';
import { TicketAddressState, ticketAddressReducer } from 'app/components/checkout-components/ticket-address/reducer/ticket-address.reducer';
import { keepAppointmentReducer, KeepAppointmentState } from '../components/keep-appointment/keep-appointment.reducer';
import { reportingReducer, ReportingState } from "../components/reporting/reporting.reducer";

export { MessageState, messageReducer, PricelevelState, CategoryFormState };


export interface AppState {
	categoryForm: CategoryFormState,
	eventServerState: {
		categories: CategoryState,
		event: EventState,
		eventCategories: EventCategoryState
		eventOverview: EventOverviewState,
		priceLevels: PricelevelState,
		ticketQuotas: TicketQuotaState,
		ticketDesigns: TicketDesignState,
		seatingplan: SeatingplanServerState
		additionalCharges: AdditionalChargeState
	},
	messages: MessageState,
	eventsOnSale: fromEventsOnSale.EventsOnSaleState
	shoppingCart: ShoppingCartState,
	customersState: CustomersState
	checkout: CheckoutState,
	ticketAddress: TicketAddressState,
	orders: OrderState,
	venuesState: VenueState,
	merchantState: MerchantState,
	sponsorState: SponsorState,
	seatingplanState: SeatingplanState,
	openItemsState: OpenItemsState,
	keepAppointment: KeepAppointmentState,
	reporting: ReportingState
}

export const reducers: ActionReducerMap<AppState> = {
	categoryForm: categoryFormReducer,
	messages: messageReducer,
	eventsOnSale: fromEventsOnSale.reducerFunction,
	shoppingCart: shoppingCartReducer,
	customersState: customersReducer,
	checkout: checkoutReducer,
	ticketAddress: ticketAddressReducer,
	orders: orderReducer,
	eventServerState: combineReducers({
		eventOverview: eventOverviewReducer,
		event: eventReducer,
		eventCategories: eventCategoryReducer,
		categories: categoryReducer,
		priceLevels: pricelevelReducer,
		ticketQuotas: ticketQuotaReducer,
		ticketDesigns: ticketDesignReducer,
		seatingplan: seatingplanServeReducer,
		additionalCharges: additionalChargeReducer
	}),
	venuesState: venueReducer,
	merchantState: merchantsReducer,
	sponsorState: sponsorsReducer,
	seatingplanState: seatingplanReducer,
	openItemsState: openItemsReducer,
	keepAppointment: keepAppointmentReducer,
	reporting: reportingReducer
};

export default reducers;



// WEBPACK FOOTER //
// ./src/app/reducers/index.ts